<template>
  <div class="mb-4 p-3 border rounded">
    <h2>Сгенерировать один рецепт по названию</h2>

    <!-- Form for user input -->
    <form class="form" action="javascript:void(0);">
      <!-- Dish Name Input -->
      <div class="mt-3 mb-3">
        <label for="dishNameSingle" class="form-label"
          >Введите название блюда:</label
        >
        <input
          type="text"
          id="dishNameSingle"
          v-model="dishName"
          class="form-control"
        />
      </div>

      <div class="d-flex align-items-center">
        <!-- Button Generate -->
        <button @click="generateRecipe" class="btn btn-outline-success">
          Сгенерировать
        </button>

        &nbsp;

        <!-- Button Add -->
        <button
          v-if="result && !error && !result_added"
          @click="addRecipe"
          class="btn btn-outline-primary"
        >
          Добавить
        </button>

        &nbsp;

        <!-- Button Report Error -->
        <button
          v-if="error"
          @click="reportError2"
          class="btn btn-outline-danger"
        >
          Сообщить об ошибке
        </button>
      </div>
    </form>

    <!-- Loading Spinner -->
    <div
      v-if="loading"
      class="d-flex justify-content-center align-items-center mt-5 mb-5"
      style="min-height: 100px"
      role="status"
    >
      <div
        class="spinner-border text-success"
        style="width: 3rem; height: 3rem"
      >
        <span class="visually-hidden">Загрузка...</span>
      </div>
    </div>

    <!-- Status messages -->
    <div v-if="message" class="mt-3 text-center">{{ message }}</div>

    <!-- Error messages -->
    <div v-if="error" class="mt-3 text-danger">{{ error }}</div>

    <!-- Result -->
    <div v-if="result && !result_added" class="container mt-3 border">
      <button
        @click="copyToClipboard"
        class="btn btn-sm btn-secondary copy-button float-end"
      >
        <i class="bi bi-clipboard"></i>
      </button>
      <pre><code class="language-json">{{ result }}</code></pre>
    </div>

    <!-- Full recipe -->
    <RecipeView
      v-if="recipe && result_added"
      :recipe="recipe"
      :short="false"
      @show-full="showFullRecipeInternal"
    />
  </div>
</template>

<script>
import RecipeView from "./RecipeView.vue";

// Command to generate a recipe
const CMD_RECIPE_GENERATE = "recipe.generate/";
// Command to report an error
const CMD_RECIPE_ERROR = "recipe.error2";
// Command to add a recipe
const CMD_RECIPE_ADD = "recipe.add/";
// Command to get recipe from server
const CMD_RECIPE_GET = "recipe.get/";

export default {
  name: "RecipeGenerate",
  components: { RecipeView },

  data() {
    return {
      // showFullRecipe: false, // This state seems local to RecipeView or managed by its prop
      result_added: false,
      loading: false,
      dishName: "",
      recipe: null,
      message: "",
      result: "", // Stores the raw JSON string or parsed object before adding
      error: "",
    };
  },

  mounted() {
    let that = this;
    // Add 'reader' which will receive data from WebRTC Data Channel
    // specific to this component's operations.
    this.reader = this.teoweb.addReader(function (gw, data) {
      if (gw.err) {
        // Only handle errors if this component initiated loading
        if (that.loading) {
          if (gw.err != "access-denied") {
            that.message = "";
            that.error = "Ошибка: " + gw.err;
          }
          that.loading = false;
        }
        return;
      }

      // Process answer to commands relevant to this component
      const commandBaseGenerate = CMD_RECIPE_GENERATE + that.dishName;
      const commandBaseAdd = CMD_RECIPE_ADD + that.dishName;

      switch (gw.command) {
        case CMD_RECIPE_ERROR:
        case commandBaseGenerate:
          if (
            gw.command === commandBaseGenerate ||
            (gw.command === CMD_RECIPE_ERROR && that.dishName)
          ) {
            that.error = "";
            that.result = data;
            that.loading = false;

            if (gw.command == CMD_RECIPE_ERROR) {
              that.message = "Ответ на сообщение об ошибке получен.";
            } else {
              that.message = "Рецепт сгенерирован.";
            }

            // Attempt to parse, or extract if needed
            try {
              // Test if it's already valid JSON and make it prettier
              that.result = JSON.stringify(JSON.parse(data), null, 2);
            } catch (err) {
              try {
                const extracted = that.extractJSONFromMarkdown(data);
                if (extracted) {
                  that.result = extracted; // Store the extracted JSON string
                } else {
                  // If not markdown and not plain JSON, treat as plain text or show error
                  // For now, we assume it might be plain text if not JSON/Markdown
                  // Or, if an error is preferred:
                  // that.error = "Не удалось распознать формат ответа.";
                  // that.result = data; // Show raw data
                }
              } catch (e) {
                that.error = "Ошибка извлечения JSON: " + e.message;
                that.result = data;
              }
            }
          }
          break;

        case commandBaseAdd:
          if (that.dishName) {
            // Ensure this response is for an active operation
            that.error = "";
            that.loading = false;
            that.result_added = true;
            that.message = "Рецепт успешно добавлен.";

            // Get full recipe data
            that
              .sendCmd(CMD_RECIPE_GET + data)
              .then((recipeData) => {
                try {
                  that.recipe = JSON.parse(recipeData);
                } catch (e) {
                  that.error = "Ошибка парсинга данных рецепта: " + e.message;
                  that.recipe = null;
                }
              })
              .catch((err) => {
                that.error = "Ошибка получения рецепта: " + err;
                that.recipe = null;
              });
          }
          break;
      }
    });
  },

  unmounted() {
    this.teoweb.delReader(this.reader);
  },

  methods: {
    showFullRecipeInternal() {
      // This method is here if RecipeView emits 'show-full' and this component
      // needs to react. Currently, RecipeView's 'short' prop controls its
      // display directly.
      // If `showFullRecipe` data property was used, you'd toggle it here.
      console.log(
        "showFullRecipeInternal called, RecipeView should be displaying full recipe."
      );
    },

    generateRecipe() {
      if (!this.dishName.trim()) {
        this.message = "";
        this.error = "Пожалуйста, введите название блюда.";
        return;
      }
      this.error = "";
      this.result = "";
      this.recipe = null;
      this.result_added = false;
      this.loading = true;
      this.message = `Генерируем рецепт ${this.dishName}...`;
      this.teoweb.sendCmd(CMD_RECIPE_GENERATE + this.dishName);
    },

    reportError2() {
      if (this.error) {
        // Send the current error related to this component
        this.teoweb.sendCmd(CMD_RECIPE_ERROR, this.error);
        this.message = "Сообщение об ошибке отправлено.";
      } else {
        this.message = "Нет ошибки для отправки.";
      }
    },

    extractJSONFromMarkdown(markdown) {
      const regex = /```json\s*([\s\S]*?)\s*```/;
      const match = markdown.match(regex);
      if (match && match[1]) {
        return match[1].trim();
      }
      return null;
    },

    addRecipe() {
      if (!this.result || !this.dishName) {
        this.error = "Нет данных для добавления рецепта.";
        return;
      }
      // Ensure `this.result` is a stringified JSON
      let payload;
      if (typeof this.result === "object") {
        payload = JSON.stringify(this.result);
      } else {
        // Attempt to parse to validate, then stringify.
        // This handles cases where it might be a string that's not yet
        // parsed from markdown.
        try {
          JSON.parse(this.result);
          payload = this.result;
        } catch (e) {
          this.error = "Данные для добавления не являются корректным JSON.";
          return;
        }
      }

      this.loading = true;
      this.message = `Добавляем рецепт "${this.dishName}" в базу...`;
      this.error = "";
      this.teoweb.sendCmd(CMD_RECIPE_ADD + this.dishName, payload);
    },

    copyToClipboard() {
      let textToCopy = this.result;
      if (typeof this.result === "object") {
        textToCopy = JSON.stringify(this.result, null, 2);
      }
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          this.message = "Рецепт скопирован в буфер обмена.";
          setTimeout(() => {
            if (this.message === "Рецепт скопирован в буфер обмена.")
              this.message = "";
          }, 3000);
        })
        .catch((err) => {
          this.error = "Ошибка копирования: " + err;
        });
    },
  },
};
</script>

<style scoped>
.copy-button {
  margin-right: -12px;
  margin-top: 5px;
}
pre {
  padding-top: 10px;
  white-space: pre-wrap; /* Allow text to wrap in pre block */
  word-break: break-all; /* Break long words */
}
</style>
